import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AUTH_REFRESH_QUERY_KEY } from './useAuthRefresh';
import { AxiosErrorResponse } from '../../interfaces/errorResponse';
import { AdminAuthService } from '../../services/admin-auth';
import { useNotification } from '../../+state/useNotification';
import { parseAxiosError } from '../../services/axios';

export const useLogout = () => {
  const {openErrorToast} = useNotification();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => AdminAuthService.logout(),
    onError: (err: AxiosErrorResponse) => openErrorToast(parseAxiosError(err)),
    onSettled: () => queryClient.invalidateQueries([AUTH_REFRESH_QUERY_KEY]),
  });
};